export default {
  byId: {
    app: {
      name: 'Application',
      statusText: 'loading ...',
      status: null
    },
    server: {
      name: 'Server',
      statusText: 'loading ...',
      status: null
    },
    cache: {
      name: 'Cache',
      statusText: 'loading ...',
      status: null
    },
    database: {
      name: 'Database',
      statusText: 'loading ...',
      status: null
    },
    storage: {
      name: 'Storage',
      statusText: 'loading ...',
      status: null
    }
  },
  map: ['app', 'server', 'cache', 'database', 'storage']
};
